import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Plus, Trash2, Loader2, Save } from "lucide-react";
import { toast } from "sonner";

const field = "w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm outline-none focus:border-primary/50";

export default function AdminCategories() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const [fr, setFr] = useState("");
  const [en, setEn] = useState("");

  const { data, isLoading } = useQuery({ queryKey: ["admin-cats"], queryFn: async () => (await api.get("/admin/categories")).data });

  const add = async () => {
    if (!fr) return toast.error("Nom (FR) requis");
    await api.post("/admin/categories", { name: { fr, en }, order: (data?.length || 0) });
    setFr(""); setEn("");
    toast.success("Catégorie ajoutée");
    qc.invalidateQueries({ queryKey: ["admin-cats"] });
  };
  const del = async (id) => {
    await api.delete(`/admin/categories/${id}`);
    qc.invalidateQueries({ queryKey: ["admin-cats"] });
  };

  if (isLoading) return <div className="flex h-96 items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;

  return (
    <div className="max-w-3xl">
      <h1 className="font-heading text-2xl font-bold tracking-tight">{t("admin.categories")}</h1>

      <div className="mt-6 flex flex-col gap-3 rounded-xl border border-white/5 bg-[hsl(var(--surface-elevated))] p-4 md:flex-row md:items-end">
        <div className="flex-1"><label className="mb-1 block text-xs uppercase tracking-widest text-muted-foreground">Nom (FR)</label>
          <input className={field} value={fr} onChange={(e) => setFr(e.target.value)} data-testid="cat-fr" /></div>
        <div className="flex-1"><label className="mb-1 block text-xs uppercase tracking-widest text-muted-foreground">Name (EN)</label>
          <input className={field} value={en} onChange={(e) => setEn(e.target.value)} data-testid="cat-en" /></div>
        <button onClick={add} data-testid="cat-add" className="flex items-center justify-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-[hsl(var(--primary))]/90">
          <Plus className="h-4 w-4" /> Ajouter
        </button>
      </div>

      <div className="mt-4 divide-y divide-white/5 rounded-xl border border-white/5 bg-[hsl(var(--surface-elevated))]">
        {data.map((c) => (
          <div key={c.id} className="flex items-center justify-between px-4 py-3" data-testid={`cat-row-${c.id}`}>
            <div>
              <p className="font-medium">{c.name.fr} {c.is_demo && <span className="text-[10px] text-muted-foreground">[DÉMO]</span>}</p>
              <p className="text-xs text-muted-foreground">{c.name.en || "—"}</p>
            </div>
            <button onClick={() => del(c.id)} className="rounded-md bg-white/5 p-2 text-muted-foreground hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
